import { AxiosInstance } from "axios";
import { Update } from "../../components/Insights";
import { HistoryControlType } from "../../types/historyControl";

// export const postRiskThemes = async (axiosInstance: AxiosInstance, year: number) => {
//   return await axiosInstance
//       .get(`/year/${year}`)
//       .then(response => response.data.risk_themes);
// };

export const createUpdate = async (axios: AxiosInstance, body: Update) => {
  return await axios.put("/rest/risk-update/", body);
};

export const addHistoryControl = async (
  axiosInstance: AxiosInstance,
  historyControl: { id: number; control: HistoryControlType }
) => {
  return await axiosInstance
    .put(
      `/rest/risk-item-evolution/v1/create/${historyControl.id}`,
      historyControl.control
    )
    .then(response => response.data);
};

export const copyRisksBetweenYears = async (
  axiosInstance: AxiosInstance,
  params: { sourceYear: number; targetYear: number }
) => {
  return await axiosInstance
    .post(
      `/rest/risk/v1/copy-year/${params.sourceYear}/to/${params.targetYear}`
    )
    .then(response => response.data);
};

export interface CreateCollaboratorDto {
  name: string;
  login: string;
  email: string;
}

export interface CollaboratorDto {
  login: string;
  id: number;
}

export const createCollaborator = async (
  axiosInstance: AxiosInstance,
  data: CreateCollaboratorDto
) => {
  return await axiosInstance
    .post(`/rest/collaborator/v1/create`, data)
    .then(response => response.data);
};

export interface CreateTagPayload {
  name: string;
  description?: string | null;
}

export const createTag = async (
  axiosInstance: AxiosInstance,
  data: CreateTagPayload
) => {
  return await axiosInstance
    .post(`/rest/tags`, data)
    .then(response => response.data);
};
